import { useQuery, useMutation } from 'react-query';
import { request } from '../utils/axios-utils';

export const testAPI = params => {
    return request({ url: '/supportingArticles', method: 'GET', params });
};

const fetchAllTypes = () => {
    return request({ url: '/supportingArticles/getAllTypes', method: 'GET' });
};

const fetchSupportingArticles = params => {
    return request({ url: 'supportingArticles/list', method: 'GET', params });
};

export const useGetSupportingArticles = onSuccess => {
    return useMutation(params => fetchSupportingArticles(params), {
        onSuccess: onSuccess,
    });
};

export const useTypes = onSuccess => {
    return useQuery('allTypes', fetchAllTypes, {
        refetchOnWindowFocus: false,
        onSuccess: onSuccess,
        select: data => data.data,
    });
};

const deleteSupportingArticle = supportingArticleId => {
    return request({ url: `/supportingArticles/${supportingArticleId}`, method: 'DELETE' });
};

export const useDeleteSupportingArticle = (onSuccess, onError) => {
    return useMutation(deleteSupportingArticle, {
        onSuccess: onSuccess ? onSuccess : null,
        onError: onError ? onError : null,
    });
};

const UpdateSupportingArticle = bodyObj => {
    return request({ url: `/supportingArticles/tags?id=${bodyObj.id}`, method: 'PUT', data: { productTags: bodyObj?.productTags } });
};

export const useUpdateSupportingArticle = (onSuccess, onError) => {
    return useMutation(UpdateSupportingArticle, {
        onSuccess: onSuccess ? onSuccess : null,
        onError: onError ? onError : null,
    });
};

const getSupportingArticlesFilters = params => {
    return request({ url: `/supportingArticles/filters`, method: 'GET', params });
};

export const useGetSupportingArticlesFilters = (onSuccess, onError) => {
    return useMutation(getSupportingArticlesFilters, {
        refetchOnWindowFocus: false,
        onSuccess: onSuccess,
        select: data => data.data,
    });
};
